module.exports = __webpack_public_path__ + "static/media/ellipse-right.d84553dc.svg";